import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const ITEMS = [
  { id: "Minuman Kolagen", en: "Collagen Drink", match: ["kolagen", "collagen"] },
  { id: "Minuman Fiber", en: "Fiber Drink", match: ["fiber"] },
  { id: "Minuman Kopi", en: "Coffee Drink", match: ["kopi", "coffee"] },
  { id: "Minuman Herbal", en: "Herbal Drink", match: ["herbal"] },
  { id: "Teh Susu", en: "Milk Tea", match: ["teh"] },
  { id: "Minuman Cokelat", en: "Chocolate Drink", match: ["cokelat", "coklat", "chocolate"] },
  { id: "Minuman Susu", en: "Milk Drink", match: ["susu"] },
];

const findProduct = (products, item) => {
  const scored = products
    .map((p) => {
      const hay = `${p.slug || ""} ${p.name || ""} ${p.category || ""}`.toLowerCase();
      const hit = item.match.find((k) => hay.includes(k));
      if (!hit) return null;
      if (item.id.includes("Susu") && (hay.includes("teh") || hay.includes("tea"))) return null;
      return { p, hit };
    })
    .filter(Boolean);
  return scored[0]?.p || null;
};

export const useProductMenu = (lang = "id") => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    api.get("/products", { params: { published: true } })
      .then(({ data }) => setProducts(Array.isArray(data) ? data : []))
      .catch(() => {});
  }, []);

  const items = ITEMS.map((item) => {
    const found = findProduct(products, item);
    return {
      label: lang === "en" ? item.en : item.id,
      to: found ? `/produk/${found.slug}` : "/produk",
    };
  });

  const extras = products.filter((p) => !ITEMS.some((item) => findProduct([p], item)));
  extras.forEach((p) => {
    items.push({ label: p.name, to: `/produk/${p.slug}` });
  });

  return items;
};
